import Registry from "./models/Registry";
import Toggle from "./components/Toggle";
import MainMenu from "./components/MainMenu";
import Slideshow from "./components/Slideshow";
import Preloader from "./components/Preloader";
import AOScont from "./components/AOScont";
import CenteredSlider from "./components/CenteredSlider";
import Parallax from "./components/Parallax";
import Accordion from "./components/Accordion";
import SocialShare from "./components/SocialShare";
import GalleryFilter from "./components/GalleryFilter";
import Sticky from "./components/Sticky";
import GoogleMaps from "./components/GoogleMaps";
import cssVars from 'css-vars-ponyfill';
import ExtendBg from "./components/ExtendBg";

class App {
  constructor(context) {
    this.registry = new Registry();
    this.registerComponents();
    this.initController(context);
  }

  initController(context) {
    context = this.registry.getContext(context);
    new context();
  }

  registerComponents() {
    this.registry
      .addComponent('Preloader', Preloader)
      .addComponent('AOScont', AOScont)
      .addComponent('Toggle', Toggle)
      .addComponent('MainMenu', MainMenu)
      .addComponent('Slideshow', Slideshow)
      .addComponent('CenteredSlider', CenteredSlider)
      .addComponent('Parallax', Parallax)
      .addComponent('Accordion', Accordion)
      .addComponent('SocialShare', SocialShare)
      .addComponent('GalleryFilter', GalleryFilter)
      .addComponent('Sticky', Sticky)
      .addComponent('GoogleMaps', GoogleMaps)
      .addComponent('ExtendBg', ExtendBg)
    ;
  }

}

window.AppInit = (context) => {
  new App(context);
  cssVars();
};
